<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">

            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.createdAt}`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYHHSSDateFormat(item[$constant.table.SALE_AGENT_KEY.createdAt]) }}
                </span>
            </template>

            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.id}`]="{ item }">
                <span>
                    {{ $t(`${item.id}`) }}
                </span>
            </template>

            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.isVerified}`]="{ item }">
                <div
                    :class="{
                        'approve-item': item.isVerified === $constant.APPROVE_STATUS,
                        'reject-item': item.isVerified === $constant.REJECT_STATUS,
                        'waiting-item': item.isVerified === $constant.WAITING_STATUS
                    }">
                    {{ $t(`status.${item.isVerified}`) }}
                </div>
            </template>
            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.isActive}`]="{ item }">
                <button-status-field
                    disableClick
                    hideIcon
                    :status="item[$constant.table.SALE_AGENT_KEY.isActive]"/>
            </template>

            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.totalAmount}`]="{ item }">
                <div class="font-weight-bold">{{ $util.getCurrencyFormat(item.totalAmount) }}</div>
            </template>

            <template v-slot:[`item.${$constant.table.SALE_AGENT_KEY.totalCommission}`]="{ item }">
                <div class="d-flex flex-row align-items-center">
                    <img
                        v-if="item.isPaid"
                        class="mr-3"
                        style="width:24px;height:24px"
                        src="../../assets/check.png"/>

                    <img
                        v-else
                        class="mr-3"
                        style="width:24px;height:24px"
                        src="../../assets/check_gray.png"/>

                    <div class="font-weight-bold text-end">{{ $util.getCurrencyFormat(item.totalCommission) }}</div>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'
import ButtonStatusField from '@/components/fields/ButtonStatusField'

export default {
    name: 'SaleAgentTable',

    components: {
        BaseTable,
        ButtonStatusField
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        },

        roles: {
            type: String
        }
    },

    mounted () {
        console.log(this.$route.name)
    },

    data () {
        return {
            headers: [
                {
                    text: (this.$route.name === 'AndamandaStaffList' ? this.$t('saleAgent.table.staffId') : this.$t('saleAgent.table.saleId')),
                    value: this.$constant.table.SALE_AGENT_KEY.id,
                    width: '160px'
                },
                {
                    text: this.$t('saleAgent.table.requestDate'),
                    value: this.$constant.table.SALE_AGENT_KEY.createdAt,
                    width: '160px'
                },
                {
                    text: this.$t('saleAgent.table.company'),
                    value: this.$constant.table.SALE_AGENT_KEY.organization,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.name'),
                    value: this.$constant.table.SALE_AGENT_KEY.name,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.type'),
                    value: this.$constant.table.SALE_AGENT_KEY.subRoles,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.ticketAmount'),
                    value: this.$constant.table.SALE_AGENT_KEY.totalTickets,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.saleTotal'),
                    value: this.$constant.table.SALE_AGENT_KEY.totalAmount,
                    sortable: false,
                    align: 'right'
                },
                {
                    text: this.$t('saleAgent.table.email'),
                    value: this.$constant.table.SALE_AGENT_KEY.email,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.phone'),
                    value: this.$constant.table.SALE_AGENT_KEY.phonenumber,
                    sortable: false
                },
                {
                    text: this.$t('saleAgent.table.approveStatus'),
                    value: this.$constant.table.SALE_AGENT_KEY.isVerified,
                    sortable: false,
                    width: '160px'
                },
                {
                    text: this.$t('saleAgent.table.status'),
                    value: this.$constant.table.SALE_AGENT_KEY.isActive,
                    sortable: false,
                    width: '140px'
                },
                {
                    text: this.$t('saleAgent.table.allCommission'),
                    value: this.$constant.table.SALE_AGENT_KEY.totalCommission,
                    sortable: false,
                    width: '200px'
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items.map(item => {
                return {
                    ...item,
                    total: item.saleHistory ? item.saleHistory.reduce((result, cur) => {
                        return result + cur.total
                    }, 0) : 0
                }
            })
        }
    },

    methods: {
        onRowItemClick (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped>
.reject-item {
    border: 1px solid grey;
    display: inline-table;
    padding: 4px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 14px;
}

.waiting-item {
    color: #FAAD14;
    display: inline-table;
    background: #faad1417;
    border: 1px solid #FAAD14;
    padding: 4px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 14px;
}

.approve-item {
 color: #00C058;
    display: inline-table;
    background: #f6ffed;
    border: 1px solid #00C058;
    padding: 4px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 14px;
}
</style>
